import React from 'react';
import { Link } from 'react-router';
import qs from 'qs';

interface ILocationDescriptor {
  pathname?: string;
  query?: any;
  hash?: string;
  state?: any;
}

interface IProps {
  scrollTo?: string;

  className?: string;
  onClick?: any;
  rel?: string;
  to: string | ILocationDescriptor;
  activeClassName?: string;
}

export default class ScrollLink extends React.Component<IProps, any> {
  location(): ILocationDescriptor {
    const state = { scrollTo: this.props.scrollTo };

    if (typeof this.props.to === 'object') {
      return {
        ...this.props.to,
        state,
      };
    }

    const [pathname, search] = this.props.to.split('?', 2);

    return {
      state,
      pathname,
      query: qs.parse(search),
    };
  }

  render() {
    return (
      <Link
        className={this.props.className}
        rel={this.props.rel}
        to={this.location()}
        onClick={this.props.onClick}
        activeClassName={this.props.activeClassName}
      >
        {this.props.children}
      </Link>
    );
  }
}
